import React from 'react';
import './Header.scss';
import logo from 'assets/images/logo.png';
import titleImg from 'assets/images/gyoritrening.png';

const Header = () => {
  return (
    <header className="header">
      {/*<a href="https://course18101.realprogress.hu/" />*/}
      <img src={logo} alt="logo" className="logo" />
      <div className="title-logo">
        <img src={titleImg} alt="title" />
      </div>
    </header>
  );
};

export default Header;
